import { CoreError, CoreErrorCause } from '@domain/models/core-error'

function getErrorCode(error: Error): string | null {
  if ('code' in error && typeof error.code === 'string') {
    return error.code
  }
  return null
}

export class PodcastsErrorConverter {
  public static domainModel(fromExternalModel: unknown): CoreError {
    if (fromExternalModel instanceof CoreError) {
      return fromExternalModel
    }

    if (!(fromExternalModel instanceof Error)) {
      return new CoreError({
        cause: CoreErrorCause.Unknown,
        context: `An unknown podcasts service error happened: ${String(fromExternalModel)}`,
        underlyingException: fromExternalModel,
      })
    }

    const code = getErrorCode(fromExternalModel)
    switch (code) {
      case 'permission-denied':
        return new CoreError({
          cause: CoreErrorCause.PermissionDenied,
          context: 'Permission denied while accessing podcasts.',
          underlyingException: fromExternalModel,
        })
      case 'not-found':
        return new CoreError({
          cause: CoreErrorCause.DataNotFound,
          context: 'Podcast data was not found.',
          underlyingException: fromExternalModel,
        })
      case 'unavailable':
      case 'network-request-failed':
        return new CoreError({
          cause: CoreErrorCause.NetworkConnection,
          context: 'Podcast data is unavailable due to a network issue.',
          underlyingException: fromExternalModel,
        })
      default:
        return new CoreError({
          cause: CoreErrorCause.Unknown,
          context: fromExternalModel.message || 'Failed to process podcast data.',
          underlyingException: fromExternalModel,
        })
    }
  }
}
